import { smartTitle } from '../pipes/smart-capitalize';

export function fromSlug(slug: string): string {
  // Realizar lo opuesto a toSlug, nada más que ignorando las tildes, luego pasarle el smartTitle
  // Reemplazar guiones solo cuando están seguidos de letras, no números
  if (!slug) return '';
  const withSpaces = slug
    .toLowerCase()
    .replaceAll('-', ' ')
    .replaceAll('_', ' ')
    .trim();
  return smartTitle(withSpaces);
}

/**
 * Convierte un texto a un slug SEO-friendly
 * @param text - Texto a convertir
 * @returns Slug formateado
 */
export function toSlug(text: string): string;
/**
 * Convierte múltiples textos a un slug SEO-friendly combinado
 * @param parts - Partes a combinar (marca, modelo, año, etc.)
 * @returns Slug formateado combinado
 */
export function toSlug(...parts: string[]): string;
export function toSlug(...parts: string[]): string {
  // Si solo hay un argumento, mantener comportamiento original
  if (parts.length === 1) {
    const text = parts[0];
    return text
      .toLowerCase() // Convertir a minúsculas
      .replaceAll('-', '')
      .normalize('NFD') // Separar letras con tilde
      .replace(/[\u0300-\u036f]/g, '') // Eliminar marcas diacríticas (tildes)
      .replace(/[^a-z0-9\s-]/g, '') // Eliminar caracteres especiales excepto espacios y guiones
      .trim() // Quitar espacios iniciales/finales
      .replace(/\s+/g, '-') // Reemplazar espacios por guiones
      .replace(/-+/g, '-'); // Reemplazar múltiples guiones por uno solo
  }
  
  // Si hay múltiples partes, combinarlas
  const combined = parts
    .filter(part => part != null && part !== '') // Filtrar valores nulos/vacíos
    .map(part => {
      return String(part)
        .toLowerCase() // Convertir a minúsculas
        .normalize('NFD') // Separar letras con tilde
        .replace(/[\u0300-\u036f]/g, '') // Eliminar marcas diacríticas (tildes)
        .replace(/[^a-z0-9\s-]/g, '') // Eliminar caracteres especiales excepto espacios y guiones
        .trim() // Quitar espacios iniciales/finales
        .replace(/\s+/g, '-') // Reemplazar espacios por guiones
        .replace(/-+/g, '-'); // Reemplazar múltiples guiones por uno solo
    })
    .filter(slug => slug !== '') // Filtrar slugs vacíos
    .join('-'); // Unir con guiones
  
  // Colapsar guiones múltiples y hacer trim de guiones al inicio/final
  return combined.replace(/-+/g, '-').replace(/^-+|-+$/g, '');
}

/**
 * Genera un slug único para un taller combinando nombre y ciudad
 * @param customer - Nombre del cliente/taller
 * @param ciudad - Ciudad del taller
 * @returns Slug único para el taller
 */
export function generateWorkshopSlug(customer: string, ciudad: string): string {
  const customerSlug = toSlug(customer);
  const ciudadSlug = toSlug(ciudad);
  return `${customerSlug}-${ciudadSlug}`;
}
